import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

let _isIframeMode = false;
export function setIframeMode(val) { _isIframeMode = val; }

const api = axios.create({
  baseURL: API,
});

// Attach token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('qp_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !_isIframeMode) {
      localStorage.removeItem('qp_token');
      localStorage.removeItem('qp_user');
      localStorage.removeItem('qp_brand');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
export { API };
